// Currency utility functions

export const getCurrency = () => {
  const companyInfo = localStorage.getItem('companyInfo');
  if (companyInfo) {
    const info = JSON.parse(companyInfo);
    return info.currency || 'NOK';
  }
  return 'NOK';
};

export const getCurrencySymbol = (currency) => {
  const symbols = {
    'NOK': 'kr',
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'SEK': 'kr',
    'DKK': 'kr',
    'CHF': 'CHF',
    'CAD': 'CA$',
    'AUD': 'A$',
    'JPY': '¥'
  };
  return symbols[currency] || currency;
};

export const formatCurrency = (amount, currency = null) => {
  if (currency === null) {
    currency = getCurrency();
  }

  const safeAmount = Number.isFinite(Number(amount)) ? Number(amount) : 0;
  const symbol = getCurrencySymbol(currency);
  const formatted = safeAmount.toFixed(2);
  
  // For currencies with symbol before amount (like USD, EUR, GBP)
  if (['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'JPY'].includes(currency)) {
    return `${symbol}${formatted}`;
  }
  
  // For currencies with symbol after amount (like NOK, SEK, DKK)
  return `${formatted} ${symbol}`;
};
